import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

export function CaseHistoryDetailsEmptyState() {
  return (
    <Stack sx={{ flex: 1, justifyContent: "center", height: "100%" }} spacing={5}>
      <Text semibold variant="h4" sx={{ textWrap: "balance", textAlign: "center" }}>
        This case has no visits
      </Text>
      <Text
        semibold
        variant="body2"
        sx={{ paddingBottom: 8, textWrap: "balance", textAlign: "center" }}
      >
        Check back when you book a visit with this case!
      </Text>
    </Stack>
  );
}
